<template>
<!-- Main sidebar -->
<div class="sidebar sidebar-dark sidebar-main sidebar-expand-md">

    <!-- Sidebar mobile toggler -->
    <div class="sidebar-mobile-toggler text-center">
        <router-link to="#" class="sidebar-mobile-main-toggle">
            <i class="icon-arrow-left8"></i>
        </router-link>
        {{ $t("Navigation") }}
        <router-link to="#" class="sidebar-mobile-expand">
            <i class="icon-screen-full"></i>
            <i class="icon-screen-normal"></i>
        </router-link>
    </div>
    <!-- /sidebar mobile toggler -->

    <!-- Sidebar content -->
    <div class="sidebar-content">
        <!-- Main navigation -->
        <div class="card card-sidebar-mobile">
            <ul class="nav nav-sidebar" data-nav-type="accordion">

                <!-- Main -->
                <li class="nav-item">
                    <router-link :to="{name: 't.a.home'}" class="nav-link"><i class="fas fa-home"></i><span>{{ $t("Home") }}</span></router-link>
                </li>

                <!-- Dashboard -->
                <li class="nav-item">
                     <router-link :to="{name: 't.a.dashboard'}" class="nav-link disabled"><i class="fas fa-home"></i><span>{{ $t("Dashboard") }}</span></router-link>
                </li>

                <!-- Sales -->
                <li class="nav-item nav-item-submenu">
                    <span class="nav-link cursor-pointer"><i class="fas fa-usd-circle"></i><span>{{$t("Sales")}}</span></span>
                    <ul class="nav nav-group-sub" data-submenu-title="Layouts">
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.sales.billings'}" class="nav-link">{{$t("Billings")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.service-credit.list'}" class="nav-link">{{$t("Service Credit")}}</router-link>
                        </li>
                        <!-- <li class="nav-item">
                            <router-link :to="{name: 't.a.sales.billings'}" class="nav-link">{{$t("Quotations")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.sales.billings'}" class="nav-link">{{$t("Invioces")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.sales.billings'}" class="nav-link">{{$t("Credit Note")}}</router-link>
                        </li> -->
                    </ul>
                </li>

                <!-- Customers -->
                <li class="nav-item nav-item-submenu">
                    <span class="nav-link cursor-pointer"><i class="fas fa-address-card"></i><span>{{$t("Customers")}}</span></span>
                    <ul class="nav nav-group-sub" data-submenu-title="Layouts">
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.leads'}" class="nav-link">{{$t("Leads")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.customer'}" class="nav-link">{{$t("Customers")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.customer.clientfollowup'}" class="nav-link disabled">{{$t("Client Follow Up")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.store'}" class="nav-link">{{$t("Stores")}}</router-link>
                        </li>
                    </ul>
                </li>

                <!-- Marketing -->
                <li class="nav-item nav-item-submenu">
                    <span class="nav-link cursor-pointer"><i class="fas fa-badge-percent"></i><span>{{$t("Marketing")}}</span></span>
                    <ul class="nav nav-group-sub" data-submenu-title="Layouts">
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.coupons'}" class="nav-link">{{$t("Coupons")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.promations'}" class="nav-link">{{$t("Promotions")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.monthly-generation'}" class="nav-link">{{$t("Monthly Generation")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.marketing.clientfollowup'}" class="nav-link disabled">{{$t("Client Follow Up")}}</router-link>
                        </li>
                    </ul>
                </li>

                <!-- Utilities -->
                <li class="nav-item nav-item-submenu">
                    <span class="nav-link cursor-pointer"><i class="fas fa-wrench"></i><span>{{$t("Utilities")}}</span></span>
                    <ul class="nav nav-group-sub" data-submenu-title="Layouts">
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.adminactivitylog'}" class="nav-link disabled">{{$t("Admin Activity Log")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.selleractivitylog'}" class="nav-link disabled">{{$t("Seller Activity Log")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.notificationlog'}" class="nav-link disabled">{{$t("Notification Log")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.adminlog'}" class="nav-link disabled">{{$t("Admin Log")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.attemptslog'}" class="nav-link disabled">{{$t("Attempts Log")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.announcement'}" class="nav-link">{{$t("Announcement")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.import'}" class="nav-link">{{$t("Import")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.export'}" class="nav-link">{{$t("Export")}}</router-link>
                        </li>
                    </ul>
                </li>

                <!-- Report -->
                <li class="nav-item nav-item-submenu">
                    <span class="nav-link cursor-pointer"><i class="fas fa-chart-line"></i><span>{{$t("Report")}}</span></span>
                    <ul class="nav nav-group-sub" data-submenu-title="Layouts">
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.salereport'}" class="nav-link disabled">{{$t("Sale Report")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.moduleusagereport'}" class="nav-link disabled">{{$t("Module Usage Report")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.planreport'}" class="nav-link disabled">{{$t("Plan Report")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.couponusagereport'}" class="nav-link disabled">{{$t("Coupon Usage Report")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.promotionusagereport'}" class="nav-link disabled">{{$t("Promation Usage Report")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.exportreport'}" class="nav-link">{{$t("Export Report")}}</router-link>
                        </li>
                    </ul>
                </li>

                <!-- Settings -->
                <li class="nav-item nav-item-submenu">
                    <span class="nav-link cursor-pointer"><i class="fas fa-cog"></i><span>{{$t("Settings")}}</span></span>
                    <ul class="nav nav-group-sub" data-submenu-title="Layouts">
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.genaralsettings'}" class="nav-link disabled">{{$t("Genaral Settings")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.white_label'}" class="nav-link">{{$t("Whitelabel")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.plans'}" class="nav-link disabled">{{$t("Plans")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.staff'}" class="nav-link disabled">{{$t("Staff")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.role'}" class="nav-link disabled">{{$t("Role")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.managelanguage'}" class="nav-link disabled">{{$t("Manage Language")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.currencies'}" class="nav-link disabled">{{$t("Currencies")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.tag-management'}" class="nav-link">{{$t("Tag Management")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.saletaxes'}" class="nav-link disabled">{{$t("Sale Taxes")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.notificationtemplates'}" class="nav-link disabled">{{$t("Notification Templates")}}</router-link>
                        </li>
                    </ul>
                </li>

                <!-- Resoucre -->
                <li class="nav-item nav-item-submenu">
                    <span class="nav-link cursor-pointer"><i class="fas fa-folder-open"></i><span>{{$t("Resource")}}</span></span>
                    <ul class="nav nav-group-sub" data-submenu-title="Layouts">
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.bank'}" class="nav-link">{{$t("Bank")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.building-type'}" class="nav-link">{{$t("Building Type")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.country'}" class="nav-link">{{$t("Country")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.currency'}" class="nav-link">{{$t("Currency")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.customer-group'}" class="nav-link">{{$t("Customer Group")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.delivery'}" class="nav-link">{{$t("Delivery")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.gender'}" class="nav-link">{{$t("Gender")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.industry'}" class="nav-link">{{$t("Industry")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.integrationtype'}" class="nav-link">{{$t("Integration Type")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.label'}" class="nav-link">{{$t("Label")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.receipt'}" class="nav-link">{{$t("Receipt")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.tax_invoice'}" class="nav-link">{{$t("Tax Invoice")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.unit'}" class="nav-link">{{$t("Unit")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.user'}" class="nav-link">{{$t("User")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.vat'}" class="nav-link">{{$t("Vat")}}</router-link>
                        </li>
                    </ul>
                </li>
                <!-- Import -->
                <!-- <li class="nav-item">
                    <router-link :to="{name: 't.a.import_merchant'}" class="nav-link disabled"><i class="fas fa-home"></i><span>{{ $t("Import") }}</span></router-link>
                </li> -->
                 <!-- Domain -->
                 <li class="nav-item">
                    <router-link :to="{name: 't.a.domain'}" class="nav-link"><i class="far fa-globe"></i><span>{{ $t("Domain") }}</span></router-link>
                </li>

                <!-- Tools -->
                <li class="nav-item nav-item-submenu">
                    <span class="nav-link cursor-pointer"><i class="fas fa-screwdriver-wrench"></i><span>{{$t("Tools")}}</span></span>
                    <ul class="nav nav-group-sub" data-submenu-title="Layouts">
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.emailblacklist'}" class="nav-link">{{$t("Email Blacklist")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.emailwhitelist'}" class="nav-link">{{$t("Email Whitelist")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.check_user'}" class="nav-link">{{$t("Check User")}}</router-link>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <!-- /main navigation -->

    </div>
    <!-- /sidebar content -->

</div>
<!-- /main sidebar -->
</template>

<script>
export default {
    name: 'LeftMenu',
}
</script>


// WEBPACK FOOTER //
// src/layouts/web/admin/LeftMenu.vue